<template>
    <div v-if="bizAuth.editLandlord.hasRight" class="biz-edit-landlord-page">
        <edit-landlord-comp :class="{'fixed': listIsFixed}"></edit-landlord-comp>
    </div>
</template>
<script>
import bizBreadcrumb from '@/components/bussiness/widges/tools/bizBreadcrumb.vue';
import EditLandlordComp from '@/components/bussiness/mgtCategory/landlordMgt/editLandlordComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.editLandlord.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        bizBreadcrumb,
        EditLandlordComp
    }
}
</script>
<style lang="scss" scoped>
    .biz-edit-landlord-page{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/landlordMgt/editLandlord.vue